<script>
import Modal from "@/pages/components/modal.vue";
import {useForm} from "@inertiajs/vue3";
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Recommended from "@/pages/appointments/_recommended.vue";
import EmployeeCalendar from "@/pages/appointments/partials/employee-calendar.vue";
import Collapse from "@/pages/components/collapse.vue";
import MultipleChecksOnly from "@/pages/components/form/input-only/multiple-checks.vue";
import Form from "@/pages/appointments/mixins/form";
import moment from "moment";


export default {
	components: {Modal, Recommended, EmployeeCalendar, Collapse, MultipleChecksOnly},
	mixins: [FormElements, Form],
	emits: ['update:calendar'],
	props: {
		googleClientSideKey: {
			type: String
		}
	},
	data() {
		return {
			index: 0,
			counter: 0,
			collapseIsOpen: false,
			form: useForm({
				appointments: {}
			})
		}
	},
	mounted() {
		this.add();

		$(document)
			.off('.select2custom')
			.on('select2:select.select2custom', '.customer-select', event => {
				let appointment = this.form.appointments[$(event.currentTarget).data('index')];
				this.setCustomerDetails(appointment, '.start_date', event)
			})
			.on('select2:unselect.select2custom', '.customer-select', event => this.setCustomerDetails(this.form.appointments[$(event.currentTarget).data('index')], '.start_date', event))

		$(document)
			.off('.easepickcustom')
			.on('customchange.easepickcustom', '.start_date', event => this.setEndDate(this.form.appointments[$(event.currentTarget).data('index')], event))
	},
	computed: {
		firstAppointment() {
			return Object.values(this.form.appointments)[0] ?? {};
		}
	},
	methods: {
		submit() {
			$.ajax({
				url: route('api.v1.appointments.store'),
				method: 'post',
				data: this.form.data()
			}).always(() => {
				this.close();
				this.$emit('update:calendar');
			})
		},

		async toggleCollapse() {
			let collapse = this.$refs.collapse;
			if (collapse.collapseIsOpen()) {
				this.collapseIsOpen = false;
				await collapse.closeCollapse();
			} else {
				this.collapseIsOpen = true;
				await collapse.openCollapse();
				this.$refs.employeecalendar.refresh();
			}
		},

		open(startDate, endDate, user = {}) {
			this.reset();
			this.add(startDate, endDate, user);
			this.$refs.modal.open();
		},

		close() {
			this.$refs.modal.close();
		},

		add(startDate = '', endDate = '', user = {}, customer = {}) {
        this.form.appointments[this.index] = {
          index: this.index,
          counter: this.counter,
          customer_id: customer.id ?? '',
          customer_name: customer.company ?? customer.name ?? '',
          start_date: startDate,
          end_date: endDate,
          name: this.parseName(customer),
          user_id: user.id ?? '',
          user_name: user.name ?? '',
          products: [],
          available_products: this.parseProducts(customer, customer.products ?? []),
          description: '',
          default_duration: customer.duration_in_minutes ?? 30,
        };
        this.index++;
        this.counter++;
		},

    setAppointment(info) {
      this.reset();

      let now = moment();
      let roundedStart = moment(now).startOf('minute').minute(Math.floor(now.minute() / 30) * 30);
      let end = moment(roundedStart).add(30, 'minutes');

      this.add(roundedStart.format('YYYY-MM-DD HH:mm'), end.format('YYYY-MM-DD HH:mm'), info.user, info.customer);
    },

		remove(index) {
			delete this.form.appointments[index];
		},

		reset() {
			this.index = 0;
			this.form.appointments = {};
			this.form.reset();
		},

		changeDefaultDuration(appointment) {
			let minutes = 0;
			for(let i in appointment.products) {
				let id = appointment.products[i];
				let product = appointment.available_products.filter(product => product.value == id)[0] ?? null;
				if(!product || product.duration <= 0) {
					continue;
				}
				minutes += product.duration;
			}
			if(minutes < 30) {
				minutes = 30;
			}
			appointment.default_duration = minutes;
			this.setEndDate(appointment);
		}
	}
}
</script>

<template>
	<Modal ref="modal" size="fullscreen" id="addFormModal" data-bs-backdrop="true" title="Agenda item toevoegen">
		<div class="row g-4">
			<div class="col-12 col-lg-6">
				<form @submit.prevent="submit" id="appointmentForm" class="d-flex flex-column gap-4">
					<div class="p-3 border position-relative" v-for="appointment in form.appointments" :key="appointment.counter">
						<div class="d-flex justify-content-end mb-3" v-if="appointment.index > 0">
							<button class="btn btn-danger" @click.prevent="this.remove(appointment.index)">
								<span class="bi bi-trash3-fill"></span>
							</button>
						</div>

						<Select
							:form="form"
							v-model="appointment.customer_id"
							:name="`appointments[${appointment.index}][customer_id]`"
							label="Klant"
							placeholder="Klant"
							:ajaxUrl="route('api.v1.customers.list')"
							:required="true"
							:currentValueLabel="appointment.customer_name"
							class="customer-select"
							:data-index="appointment.index"
						/>

						<Select
							:form="form"
							v-model="appointment.user_id"
							:name="`appointments[${appointment.index}][user_id]`"
							label="Werknemer"
							placeholder="Werknemer"
							:required="true"
							:ajaxUrl="route('api.v1.users.list')"
							:currentValueLabel="appointment.user_name"

						/>

						<FormGroup :class="{'align-items-center': appointment.available_products.length < 1}">
							<template #label>Producten</template>

							<i v-if="appointment.available_products.length < 1">Er zijn geen producten gekoppeld aan deze klant</i>

							<MultipleChecksOnly
								v-if="appointment.available_products.length > 0"
								:form="form"
								v-model="appointment.products"
								@update:modelValue="this.changeDefaultDuration(appointment)"
								:name="`appointments[${appointment.index}][products]`"
								:options="appointment.available_products"
								layout="vertical"
							/>
						</FormGroup>

						<Input
							:form="form"
							v-model="appointment.name"
							:name="`appointments[${appointment.index}][name]`"
							:required="true"
							label="Titel"
							layout="vertical"
						/>

						<DateTime
							:form="form"
							v-model="appointment.start_date"
							:name="`appointments[${appointment.index}][start_date]`"
							:required="true"
							label="Begin"
							class="start_date"
							:data-index="appointment.index"
						/>

						<DateTime
							:form="form"
							v-model="appointment.end_date"
							:name="`appointments[${appointment.index}][end_date]`"
							:required="true"
							label="Einde"
						/>

						<Textarea
							groupClasses="mb-0"
							:form="form"
							v-model="appointment.description"
							:name="`appointments[${appointment.index}][description]`"
							:required="true"
							label="Omschrijving"
						/>
					</div>
				</form>
			</div>

			<div class="col-12 col-lg-6">
				<div v-if="firstAppointment.user_id">
					<div class="p-3 border mb-4">
						<a class="d-flex justify-content-between text-dark card-title" href="#" @click.prevent="toggleCollapse">
							<span v-if="collapseIsOpen === false">Toon kalender</span>
							<span v-if="collapseIsOpen === true">Verberg kalender</span>
							<i class="bi bi-chevron-down" :class="{'rotate-icon-180' : collapseIsOpen, 'rotate-icon-360': !collapseIsOpen}"></i>
						</a>

						<Collapse id="create-calendar" ref="collapse">
							<div class="pt-3">
								<EmployeeCalendar
									ref="employeecalendar"
									:user-id="firstAppointment.user_id"
								/>
							</div>
						</Collapse>
					</div>
				</div>

				<Recommended
					@add:appointment="appointment => this.add(appointment.start_date, appointment.end_date, appointment.user, appointment.customer)"
					@set:appointment="setAppointment($event)"
					:googleClientSideKey="googleClientSideKey"
					:appointment="firstAppointment"
				/>
			</div>
		</div>

		<template #footer>
			<button class="btn btn-secondary" @click.prevent="close">Annuleren</button>
			<button class="btn btn-primary" form="appointmentForm">Opslaan</button>
		</template>
	</Modal>
</template>